@if ((infoMessage | hisUi) && (infoMessage | hisUi).charAt(0) !== '?') {
  @if (showPanel) {
    <div class="layoutBlock">
      <div class="columnFullWidth">
        <p-panel [header]="infoHeader | hisUi">
          <div [ngClass]="getInfoLevelClass()" [innerHTML]="infoMessage | hisUi"></div>
        </p-panel>
        <br>
        </div>
      </div>
    }
    @if (!showPanel) {
      <div [ngClass]="getInfoLevelClass()" [innerHTML]="infoMessage | hisUi"></div>
    }
  }